import styled from '@emotion/styled';

export const YaspaIFrameStyled = styled('iframe', { label: 'YaspaIFrameStyled' })`
    min-width: 400px;
    border: none;
    height: 600px;
`;

export const YaspaContainer = styled('div', { label: 'YaspaContainer' })`
    margin-top: 16px;
`;
